import { render } from "./Restauracao.vue?vue&type=template&id=7a9a70ca&scoped=true"
import script from "./Restauracao.vue?vue&type=script&lang=js"
export * from "./Restauracao.vue?vue&type=script&lang=js"

import "./Restauracao.vue?vue&type=style&index=0&id=7a9a70ca&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a9a70ca"]])

export default __exports__